import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HandoverAccessState } from '@handover/shared-types';
import { handoverAccessApi } from './handoverAccessApi';

const initialState: HandoverAccessState = {
  message: '',
  interpolation: null,
  error: null,
};

const handoverAccessSlice = createSlice({
  name: 'handoverAccess',
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<{ message: string; interpolation?: { [key: string]: string } }>) => {
      state.message = action.payload.message;
      state.interpolation = action.payload.interpolation || null;
      state.error = null;
    },
    setError: (state, action: PayloadAction<{ message: string; interpolation?: { [key: string]: string } } | null>) => {
      if (action.payload) {
        state.error = {
          message: action.payload.message,
          interpolation: action.payload.interpolation || null,
        };
      } else {
        state.error = null;
      }
      state.message = '';
      state.interpolation = null;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      handoverAccessApi.endpoints.updateHandoverAccess.matchFulfilled,
      (state, action: PayloadAction<{ message: string; interpolation?: { [key: string]: string } }>) => {
        state.message = action.payload.message;
        state.interpolation = action.payload.interpolation || null;
        state.error = null;
      }
    );
    builder.addMatcher(handoverAccessApi.endpoints.updateHandoverAccess.matchRejected, (state, action) => {
      const errorMessage = (action.payload as any)?.data?.message || action.error?.message || 'Failed to update access';
      const interpolation = (action.payload as any)?.data?.interpolation || null;

      state.error = {
        message: errorMessage,
        interpolation: interpolation,
      };
      state.message = '';
      state.interpolation = null;
    });
  },
});

export const { setMessage, setError } = handoverAccessSlice.actions;

export default handoverAccessSlice.reducer;
